import { useQuery } from '@tanstack/react-query'
import { getTypeTestQuestionsApi } from '@/api/typeTestApi'

export const useGetTypeTestQuestions = () => {
  return useQuery({
    queryKey: ['typeTestQuestions'],
    queryFn: getTypeTestQuestionsApi
  })
}
